var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "torir-spectrogram-marker" }, [
    _vm.marker.usePoint ? _c("div", { staticClass: "--point" }) : _vm._e(),
    _vm._v(" "),
    _vm.marker.text !== null
      ? _c("div", { staticClass: "--text" }, [
          _vm._v("\n\t\t" + _vm._s(_vm.marker.text) + "\n\t")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }